module.exports = __webpack_public_path__ + "img/data1.a16b97ae.png";